

/** System Brackets */
export const ADD_SYSTEM_BRACKET = 'ADD_SYSTEM_BRACKET'
export const DELETE_SYSTEM_BRACKET = 'DELETE_SYSTEM_BRACKET'
export const EDIT_SYSTEM_BRACKET = 'EDIT_SYSTEM_BRACKET'
export const GET_SYSTEM_BRACKET = 'GET_SYSTEM_BRACKET'
export const GET_SYSTEM_DEFAULT_BRACKET = 'GET_SYSTEM_DEFAULT_BRACKET'
export const GET_SYSTEM_DEFAULT_BRACKET_SUCCESS = 'GET_SYSTEM_DEFAULT_BRACKET_SUCCESS'
